<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title py-2 px-2 pb-0 mb-0">
        <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'">
          <label class="d-flex align-items-center mb-0">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" />
          </label>
        </div>
        <div [ngClass.xl]="'float-left ml-2'" [ngClass.md]="'float-left ml-2'" [ngClass.sm]="'mt-1'">
          <select [(ngModel)]="searchStatus" class="form-control">
            <option value="10" selected>{{ "ALL" | translate }}</option>
            <option value="0">{{ "PENDING" | translate }}</option>
            <option value="1">{{ "TAKEN_CHARGE" | translate }}</option>
            <option value="2">{{ "COMPLETED" | translate }}</option>
          </select>
        </div>
        <div class="float-right" [ngClass.sm]="'d-none'">
          <div class="d-inline-block">
            <label class="d-flex align-items-center mb-0"
              >{{ "SHOW" | translate }}
              <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
          <a class="btn btn-outline-primary text-primary ml-1" (click)="_utilService.popupOpenTicketIsOpen = !_utilService.popupOpenTicketIsOpen">
            {{ "MENU.OPEN_SUPPORT_REQUEST" | translate }}
          </a>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 70 : 120"
          [limit]="tableLimit"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [footerHeight]="50"
          [rows]="ticketList()"
        >
          <ngx-datatable-column name="{{ 'NAME' | translate }}" prop="id" width="200" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="text-break-line-2" [ngbTooltip]="row.title">{{ row.title }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'CATEGORY' | translate }}" prop="category_name" width="200" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.category_name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'DATE' | translate }}" prop="insert_date" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ _utilService.formatDate(row.insert_date) }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'STATE' | translate }}" prop="last_step.status" width="100" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <ng-container [ngSwitch]="row.last_step.status">
                <span class="badge badge-secondary" *ngSwitchCase="0" [ngbTooltip]="('ON_DATE' | translate) + ' ' + _utilService.formatDate(row.last_step.insert_date)">{{ "PENDING" | translate }}</span>
                <span class="badge badge-warning" *ngSwitchCase="1" [ngbTooltip]="('ON_DATE' | translate) + ' ' + _utilService.formatDate(row.last_step.insert_date)">{{ "TAKEN_CHARGE" | translate }}</span>
                <span class="badge badge-success" *ngSwitchCase="2" [ngbTooltip]="('ON_DATE' | translate) + ' ' + _utilService.formatDate(row.last_step.insert_date)">{{ "COMPLETED" | translate }}</span>
              </ng-container>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button class="bg-transparent border-0 text-primary" (click)="modalOpen(viewTicket, row.id)" [ngbTooltip]="'VIEW' | translate">
                  <span [data-feather]="'eye'" size="19" class="mr-50"></span>
                </button>
                <button class="bg-transparent border-0 text-secondary" (click)="goToEdit(row)" [ngbTooltip]="'EDIT' | translate" *ngIf="row.last_step.status === 0">
                  <span [data-feather]="'edit-2'" size="19" class="mr-50"></span>
                </button>
                <button class="bg-transparent border-0 text-danger" (click)="deleteTicket(row)" [ngbTooltip]="'DELETE' | translate" *ngIf="row.last_step.status === 0">
                  <span [data-feather]="'trash-2'" size="19" class="mr-50"></span>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column name="{{ 'NAME' | translate }}" prop="title" width="200" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col 12">
                  <div class="d-flex align-items-center justify-content-between mb-1" ngClass.md="pr-1">
                    <span>{{ row.title }}</span>
                    <span class="mr-05">{{ _utilService.formatDate(row.insert_date) }}</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-between" ngClass.md="pr-1">
                    <ng-container [ngSwitch]="row.last_step.status">
                      <span class="badge badge-secondary" *ngSwitchCase="0" [ngbTooltip]="('ON_DATE' | translate) + ' ' + _utilService.formatDate(row.last_step.insert_date)">{{ "PENDING" | translate }}</span>
                      <span class="badge badge-warning" *ngSwitchCase="1" [ngbTooltip]="('ON_DATE' | translate) + ' ' + _utilService.formatDate(row.last_step.insert_date)">{{ "TAKEN_CHARGE" | translate }}</span>
                      <span class="badge badge-success" *ngSwitchCase="2" [ngbTooltip]="('ON_DATE' | translate) + ' ' + _utilService.formatDate(row.last_step.insert_date)">{{ "COMPLETED" | translate }}</span>
                    </ng-container>
                    <div class="d-flex align-items-center justify-content-end mb-1" ngClass.md="pr-1">
                      <button class="bg-transparent border-0 text-primary" (click)="modalOpen(viewTicket, row.id)" [ngbTooltip]="'VIEW' | translate">
                        <span [data-feather]="'eye'" size="19" class="mr-50"></span>
                      </button>
                      <button class="bg-transparent border-0 text-secondary" (click)="goToEdit(row)" [ngbTooltip]="'EDIT' | translate" *ngIf="row.last_step.status === 0">
                        <span [data-feather]="'edit-2'" size="19" class="mr-50"></span>
                      </button>
                      <button class="bg-transparent border-0 text-danger" (click)="deleteTicket(row)" [ngbTooltip]="'DELETE' | translate" *ngIf="row.last_step.status === 0">
                        <span [data-feather]="'trash-2'" size="19" class="mr-50"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<ng-template #viewTicket let-modal>
  <form>
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0" *ngIf="!!currentTicket">
      <h3>{{ "DETAIL_SUPPORT_REQUEST" | translate }}</h3>
      <div class="row">
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "NAME" | translate }}:</small>
          <p>{{ currentTicket.title }}</p>
        </div>
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "CATEGORY" | translate }}:</small>
          <p>{{ currentTicket.category_name }}</p>
        </div>
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "INSERT_DATE" | translate }}:</small>
          <p>{{ _utilService.formatDate(currentTicket.insert_date) }}</p>
        </div>
        <div class="col-6">
          <small class="text-muted mb-025 pb-0 d-block">{{ "STATUS_LABEL" | translate }}:</small>
          <ng-container [ngSwitch]="currentTicket.last_step.status">
            <span class="badge badge-secondary" *ngSwitchCase="0" [ngbTooltip]="('ON_DATE' | translate) + ' ' + _utilService.formatDate(currentTicket.last_step.insert_date)">{{ "PENDING" | translate }}</span>
            <span class="badge badge-warning" *ngSwitchCase="1" [ngbTooltip]="('ON_DATE' | translate) + ' ' + _utilService.formatDate(currentTicket.last_step.insert_date)">{{ "TAKEN_CHARGE" | translate }}</span>
            <span class="badge badge-success" *ngSwitchCase="2" [ngbTooltip]="('ON_DATE' | translate) + ' ' + _utilService.formatDate(currentTicket.last_step.insert_date)">{{ "COMPLETED" | translate }}</span>
          </ng-container>
        </div>
        <div class="col-12" *ngIf="currentTicket.note">
          <small class="text-muted mb-0 pb-0">{{ "NOTE" | translate }}:</small>
          <div [innerHTML]="currentTicket.note"></div>
        </div>
        <div class="col-12" *ngIf="currentTicket.open_attachments && currentTicket.open_attachments.length > 0">
          <small class="text-muted mb-0 pb-0">{{ "FILE" | translate }}:</small>
          <div class="row align-items-center" *ngFor="let file of currentTicket?.open_attachments">
            <div class="col-12" *ngIf="!!file.filename && !!file.file_url">
              <button type="button" (click)="_utilService.getFile(file.file_url)" class="btn border-0 mr-2 px-0 text-primary" [ngbTooltip]="'VIEW' | translate">
                <span [data-feather]="'eye'" size="16"></span>
              </button>
              <span>{{ file.filename }}</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="currentTicket.last_step.response" class="row">
        <div class="col-12">
          <hr />
        </div>
        <div class="col-12">
          <h3>{{ "STAFF_RESPONSE" | translate }}</h3>
        </div>
        <div class="col-6">
          <small class="text-muted mb-0 pb-0">{{ "DATE" | translate }}:</small>
          <p>{{ _utilService.formatDate(currentTicket.last_step.insert_date) }}</p>
        </div>
        <div class="col-12 mb-1" *ngIf="currentTicket.close_attachments && currentTicket.close_attachments.length > 0">
          <small class="text-muted mb-0 pb-0">{{ "FILE" | translate }}:</small>
          <div>
            <a class="badge badge-light-secondary mr-1 mb-05" *ngFor="let att of currentTicket.close_attachments" (click)="loadAttachment(att.file_url)">{{ att.filename }}</a>
          </div>
        </div>
        <div class="col-12">
          <small class="text-muted mb-0 pb-0">{{ "RESPONSE" | translate }}:</small>
          <div [innerHTML]="currentTicket.last_step.response"></div>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button (click)="modal.close()" type="button" class="btn btn-primary">{{ "ALERT.BTN_CLOSE" | translate }}</button>
    </div>
  </form>
</ng-template>
<!-- / Modal -->

<app-modal-edit-ticket [selectedTicketId]="currentTicket.id" *ngIf="popupeditTicketIsOpen" (callbackFn)="loadTicket()" (closeModal)="closeModal()"></app-modal-edit-ticket>
